export default "__VITE_ASSET__DIQOnj5b__"